import { UndoShiftRemovalDocument } from '@frontend/graphql/mutations/undoShiftRemoval.generated'

import { useRosterActionMutation } from './useRosterActionMutation'

const useUndoShiftRemovalMutation = () => {
  const { run, isPending } = useRosterActionMutation({
    document: UndoShiftRemovalDocument,
    succeeded: (response) => Boolean(response?.undoShiftRemoval?.success),
    errorCode: 'UNDO_REMOVAL_ERROR',
    messageKey: 'errors.undo_removal_failed',
  })

  return { undoShiftRemoval: run, isPending }
}

export default useUndoShiftRemovalMutation
